jQuery(function ($) {
	// js-topMv-newsBox-slik
	$('.js-topMv-newsBox-slik').slick({
		autoplay: true,
		autoplaySpeed: 3400,
		arrows: false,
		infinite: true,
		vertical: true,
		verticalSwiping: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 3400,
	});

});
